import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, CheckCircle2, Home } from 'lucide-react';

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
const DONE_MSG = { confirm: "Thanks — we'll be in touch to lock in a day.", skip: "No problem — we've moved it to the next cycle.", call: "Thanks — we'll give you a call." };

export default function MaintenanceVisitPublicPage() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [error, setError] = useState('');
  const [notes, setNotes] = useState('');
  const [done, setDone] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/public/maintenance-visit/${token}`).then(r => setD(r.data)).catch(e => setError(e?.response?.data?.detail || 'This link is not valid.')); }, [token]);
  const reply = async (action) => {
    setBusy(true);
    try { await api.post(`/public/maintenance-visit/${token}`, { action, notes }); setDone(action); }
    catch (e) { setError(e?.response?.data?.detail || 'Could not send — please try again.'); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#F7F6F3] py-10 px-4">
      <div className="max-w-xl mx-auto">
        <div className="flex items-center gap-2 mb-6 text-[#D35400]"><Home size={20} /><span className="font-bold tracking-tight text-slate-900">Roofs To Remedy</span></div>
        {error && !d ? <p data-testid="mvisit-error">{error}</p> : !d ? <Loader2 className="animate-spin text-slate-400" /> : done ? (
          <div data-testid="mvisit-done" className="bg-white rounded-lg border border-[#E2E2DF] p-8 text-center">
            <CheckCircle2 className="mx-auto text-emerald-600 mb-3" size={36} /><p className="text-slate-700">{DONE_MSG[done]}</p>
          </div>
        ) : (
          <div data-testid="mvisit-page" className="bg-white rounded-lg border border-[#E2E2DF] p-6 sm:p-8 space-y-5">
            <h1 className="text-2xl font-bold text-slate-900">Hi {d.first_name || 'there'}, your maintenance visit is coming up</h1>
            <p className="text-sm text-slate-600">{d.address}</p>
            {d.due.length ? (
              <ul className="space-y-1.5">{d.due.map(s => <li key={s.key} className="flex justify-between text-sm border-b border-slate-100 pb-1.5"><span>{s.label}{s.free && <span className="ml-1 text-xs text-emerald-700">(free)</span>}</span><span className="text-slate-500">due {s.next_due}</span></li>)}</ul>
            ) : <p className="text-sm text-slate-500">Nothing is due right now.</p>}
            <textarea data-testid="mvisit-notes" rows={2} value={notes} onChange={e => setNotes(e.target.value)} placeholder="Anything we should know? (best days, gate code…)" className="w-full px-3 py-2 text-sm border border-slate-300 rounded-md" />
            {error && <p className="text-sm text-red-600">{error}</p>}
            <div className="grid sm:grid-cols-3 gap-2">
              <button data-testid="mvisit-confirm-btn" disabled={busy || !d.due.length} onClick={() => reply('confirm')} className="py-2.5 rounded-md bg-[#D35400] hover:bg-[#A04000] text-white text-sm font-semibold disabled:opacity-40">Yes, go ahead</button>
              <button data-testid="mvisit-skip-btn" disabled={busy || !d.due.length} onClick={() => reply('skip')} className="py-2.5 rounded-md border border-slate-300 text-sm font-semibold hover:bg-slate-50 disabled:opacity-40">Skip this time</button>
              <button data-testid="mvisit-call-btn" disabled={busy} onClick={() => reply('call')} className="py-2.5 rounded-md border border-slate-300 text-sm font-semibold hover:bg-slate-50">Please call me</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
